import 'base-styles/reset.sss';

import { h, render } from 'preact';
import { buildClientStoreData } from 'utils/clientUtils';
import PowsterWebsiteApp from 'base/powsterWebsite/powsterWebsiteApp';
import 'utils/historyPushEvent'; // Add events for when you do history.push

try {
	let url = location.origin + location.pathname.replace(/\/[^/]*$/, '/');
	// eslint-disable-next-line no-undef
	__webpack_public_path__ = url + (window.__RELATIVE_ROOT__ || '');
} catch (e) {}

/* Setting up the store
-----------------------------*/

let initialStore = buildClientStoreData(window.__INITIAL_STATE__);
// let initialStore = window.__INITIAL_STATE__;

/* Initial render of the app
----------------------------------*/

let elem = document.getElementById('app') || document.body;
render(<PowsterWebsiteApp initialStore={initialStore} />, elem, elem.firstChild);
